/**
 * In-memory state that must not outlive the signed-in person (a store of drafts' Marvin runs,
 * a device-local copy of a draft's versions), cleared by `performLogout`.
 *
 * A module registers its own cleanup here instead of logout importing it: logout sits under
 * `config/axios`, which nearly every API module imports, so logout importing a store that
 * imports an API module would be a load-time cycle. This module imports nothing.
 */
const cleanups = new Set<() => void>();

/** Run `cleanup` on sign-out; returns the way to stop. */
export function clearOnSignOut(cleanup: () => void): () => void {
    cleanups.add(cleanup);
    return () => {
        cleanups.delete(cleanup);
    };
}

/** Sign-out: every registered cleanup runs; one that throws does not stop the others. */
export function runSignOutCleanups(): void {
    for (const cleanup of cleanups) {
        try {
            cleanup();
        } catch (error) {
            console.warn("[Logout] Failed to clear in-memory state:", error);
        }
    }
}
